import { TypePillWrapper } from "./styles";
import { TypePillProps } from "./types";

export const TypePill: React.FC<TypePillProps> = ({ variant, label }) => {
  if (!label) {
    return null;
  }
  return <TypePillWrapper $variant={variant}>{label}</TypePillWrapper>;
};
